export default "__VITE_ASSET__5eeee608__"